import { z, isoZ } from 'my-zod'
import { extendedProductLineOptions } from '../../internal'
import { polarisRentalProductTypeOptions } from '../polaris-rental-product/polaris-rental-product-model'

export const rideInformationFragment = z.object({
  outfitterId: z.number(),
  customerOrderId: z.string().uuid().nullish(),
  rideGroupId: z.string().uuid().nullish(),
  beginDate: isoZ.date(),
  endDate: isoZ.date().nullish(),

  ridingStartTime: isoZ.time().nullable() /** nullable since legacy waivers have a date but no time */,
  ridingEndTime: isoZ.time().nullable() /** nullable since legacy waivers have a date but no time */,

  productLine: z.enum(extendedProductLineOptions).nullish(),
  productType: z.enum(polarisRentalProductTypeOptions).nullish()
})

export type rideInformationFragment = z.infer<typeof rideInformationFragment>
